module.exports = __webpack_public_path__ + "static/price-box-1-1-6ad35776c17bf6d8e1622858a9a4badf.jpg";